import { render, staticRenderFns } from "./rich-editor-widget.vue?vue&type=template&id=b5a38e30&scoped=true&"
import script from "./rich-editor-widget.vue?vue&type=script&lang=js&"
export * from "./rich-editor-widget.vue?vue&type=script&lang=js&"
import style0 from "./rich-editor-widget.vue?vue&type=style&index=0&id=b5a38e30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a38e30",
  null
  
)

export default component.exports